module.exports = __webpack_public_path__ + "img/s2-1.f923cb5e.jpg";